
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/chat_spaces",
      function () {
        return require("private-next-pages/chat_spaces/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/chat_spaces"])
      });
    }
  